
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16.01 18.01"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.004.018c-1.51 0-2.75 1.24-2.75 2.75V15.24c0 1.51 1.24 2.75 2.75 2.75h8c1.51 0 2.75-1.24 2.75-2.75V5.85c0-.677-.25-1.332-.703-1.836L11.289.932A2.754 2.754 0 009.24.018zm0 1.5h4.69a.75.75 0 00-.055.279v2.12c0 1.51 1.24 2.75 2.75 2.75h1.865v8.574c0 .7-.55 1.25-1.25 1.25h-8c-.7 0-1.25-.55-1.25-1.25V2.768c0-.7.55-1.25 1.25-1.25zm6.135.4c.008.01.024.006.033.016l2.764 3.082c.037.041.025.105.056.15H11.39c-.7 0-1.25-.55-1.25-1.25z","font-family":"sans-serif","overflow":"visible"}})])
          )
        }
      }
    